import banner from "../../../courses/presupuesto-ahorro.webp";

const modulo9_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-9",
  title: "🧪 Módulo 9: Avaliação Final",
  estimatedDuration: "30–45 minutos",
  format: "Exame final online + reflexão opcional",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        {
          type: "list",
          items: [
            "Verificar se você compreende os conceitos-chave do ecossistema cripto.",
            "Validar sua preparação para interagir com o mundo Web3 de forma segura e consciente.",
            "Obter seu Certificado Profissional ZyVerse em Cripto e Blockchain.",
          ],
        },
      ],
    },
    {
      id: "info",
      navLabel: "O que inclui esta avaliação?",
      title: "📝 O que inclui esta avaliação?",
      content: [
        {
          type: "paragraph",
          text: "📌 Exame final",
        },
        {
          type: "list",
          items: [
            "20 perguntas de múltipla escolha",
            "Baseadas nos módulos 1 a 8",
            "Tópicos: blockchain, criptomoedas, stablecoins, wallets, segurança, Web3, DeFi, NFTs",
            "Duração estimada: 25–30 minutos",
            "Nota mínima para aprovação: 60% de acertos",
          ],
        },
      ],
    },
    {
      id: "luego-examen",
      navLabel: "Após o exame",
      title: "📤 O que acontece após o exame?",
      content: [
        {
          type: "list",
          items: [
            "Se você acertar 10 perguntas ou mais, poderá acessar o pagamento do certificado (R$60 aprox.).",
            "O certificado será emitido em formato PDF no prazo de 3 a 5 dias úteis.",
            "Você poderá usá-lo para comprovar horas complementares, fortalecer seu currículo ou compartilhá-lo no LinkedIn.",
          ],
        },
      ],
    },
    {
      id: "examen-final",
      navLabel: "Exame Final",
      title: "📝 Exame final (sem respostas marcadas)",
      questions: [
        {
          id: "q1",
          question: "Qual é o objetivo principal de uma blockchain?",
          options: [
            { key: "a", text: "Armazenar fotos e vídeos" },
            { key: "b", text: "Validar dados pessoais" },
            {
              key: "c",
              text: "Registrar transações de forma segura e descentralizada",
            },
            { key: "d", text: "Gerar dinheiro automaticamente" },
          ],
          correct: "c",
        },
        {
          id: "q2",
          question: "O que torna a tecnologia blockchain única?",
          options: [
            { key: "a", text: "Sua velocidade" },
            { key: "b", text: "O uso de bancos tradicionais" },
            {
              key: "c",
              text: "Sua transparência e resistência a manipulações",
            },
            { key: "d", text: "Só funciona com Bitcoin" },
          ],
          correct: "c",
        },
        {
          id: "q3",
          question: "Qual criptomoeda é conhecida como “ouro digital”?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Bitcoin" },
            { key: "c", text: "Solana" },
            { key: "d", text: "USDT" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question:
            "Qual rede é conhecida pelos contratos inteligentes e aplicações descentralizadas?",
          options: [
            { key: "a", text: "Polygon" },
            { key: "b", text: "Ethereum" },
            { key: "c", text: "Stellar" },
            { key: "d", text: "Binance" },
          ],
          correct: "b",
        },
        {
          id: "q5",
          question: "O que caracteriza as stablecoins?",
          options: [
            { key: "a", text: "Sua alta volatilidade" },
            { key: "b", text: "Só servem para jogos" },
            { key: "c", text: "Mantêm um valor estável, como 1 dólar" },
            { key: "d", text: "Funcionam sem nenhum tipo de lastro" },
          ],
          correct: "c",
        },
        {
          id: "q6",
          question: "Qual é a função de uma wallet?",
          options: [
            { key: "a", text: "Guardar e gerenciar seus criptoativos" },
            {
              key: "b",
              text: "Converter criptomoeda em dinheiro físico automaticamente",
            },
            { key: "c", text: "Comprar produtos diretamente" },
            { key: "d", text: "Substituir seu banco" },
          ],
          correct: "a",
        },
        {
          id: "q7",
          question: "O que é uma seed phrase?",
          options: [
            { key: "a", text: "Um cartão de crédito" },
            { key: "b", text: "Um código QR" },
            {
              key: "c",
              text: "Um conjunto de palavras que permite recuperar sua wallet",
            },
            { key: "d", text: "Seu nome de usuário na blockchain" },
          ],
          correct: "c",
        },
        {
          id: "q8",
          question: "Qual tipo de wallet oferece mais controle ao usuário?",
          options: [
            { key: "a", text: "Custodial" },
            { key: "b", text: "Non-custodial" },
            { key: "c", text: "Digital" },
            { key: "d", text: "Bancária" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question:
            "O que pode acontecer se você compartilhar sua seed phrase?",
          options: [
            { key: "a", text: "Você receberá mais cripto" },
            { key: "b", text: "Não acontece nada" },
            { key: "c", text: "Alguém pode roubar todos os seus fundos" },
            { key: "d", text: "Você perde o acesso apenas por algumas horas" },
          ],
          correct: "c",
        },
        {
          id: "q10",
          question: "Qual é um exemplo de rede com taxas muito baixas?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Stellar" },
            { key: "c", text: "Bitcoin" },
            { key: "d", text: "Binance Smart Chain" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "O que é DeFi?",
          options: [
            { key: "a", text: "Uma empresa de tecnologia" },
            { key: "b", text: "Uma nova criptomoeda" },
            {
              key: "c",
              text: "Um sistema financeiro sem bancos ou intermediários",
            },
            { key: "d", text: "Um jogo baseado em blockchain" },
          ],
          correct: "c",
        },
        {
          id: "q12",
          question: "Para que serve um explorador blockchain?",
          options: [
            { key: "a", text: "Para jogar com NFTs" },
            {
              key: "b",
              text: "Para revisar transações públicas da rede",
            },
            { key: "c", text: "Para minerar criptomoedas" },
            { key: "d", text: "Para alterar sua chave privada" },
          ],
          correct: "b",
        },
        {
          id: "q13",
          question: "Qual é a diferença principal entre token e criptomoeda?",
          options: [
            {
              key: "a",
              text: "O token existe dentro de uma rede já existente",
            },
            { key: "b", text: "A criptomoeda é mais segura" },
            { key: "c", text: "O token só é usado em jogos" },
            { key: "d", text: "São exatamente iguais" },
          ],
          correct: "a",
        },
        {
          id: "q14",
          question: "O que é um NFT?",
          options: [
            {
              key: "a",
              text: "Um ativo digital único com propriedade verificada",
            },
            { key: "b", text: "Uma moeda estável" },
            { key: "c", text: "Um contrato de trabalho" },
            { key: "d", text: "Um arquivo sem valor" },
          ],
          correct: "a",
        },
        {
          id: "q15",
          question: "O que deve ser verificado antes de enviar criptomoedas?",
          options: [
            { key: "a", text: "O nome do destinatário" },
            {
              key: "b",
              text: "A rede correta e a compatibilidade do token",
            },
            { key: "c", text: "A cor do ícone" },
            { key: "d", text: "Se é de noite" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question: "O que é phishing no mundo cripto?",
          options: [
            { key: "a", text: "Um novo tipo de token" },
            { key: "b", text: "Um erro de envio" },
            {
              key: "c",
              text: "Uma tentativa de golpe por links ou e-mails falsos",
            },
            { key: "d", text: "O processo de compra de tokens" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "O que é um airdrop?",
          options: [
            {
              key: "a",
              text: "Recompensa em cripto recebida gratuitamente",
            },
            { key: "b", text: "Uma nova wallet" },
            { key: "c", text: "Um erro de rede" },
            { key: "d", text: "Um tipo de golpe" },
          ],
          correct: "a",
        },
        {
          id: "q18",
          question: "O que oferece uma plataforma como Stellar Quest?",
          options: [
            { key: "a", text: "Comprar carros online" },
            { key: "b", text: "Aprender jogando e ganhar XLM" },
            { key: "c", text: "Trocar dólares por cripto diretamente" },
            { key: "d", text: "Abrir uma conta bancária" },
          ],
          correct: "b",
        },
        {
          id: "q19",
          question: "Qual a diferença entre Vesseo e um banco tradicional?",
          options: [
            { key: "a", text: "A Vesseo não guarda seu dinheiro físico" },
            {
              key: "b",
              text: "A Vesseo não controla seus fundos: você tem a custódia",
            },
            { key: "c", text: "A Vesseo cobra juros" },
            { key: "d", text: "Não há diferença" },
          ],
          correct: "b",
        },
        {
          id: "q20",
          question: "Qual é a filosofia do curso?",
          options: [
            { key: "a", text: "Ganhe dinheiro rápido" },
            {
              key: "b",
              text: "Entenda antes de investir e aja com segurança",
            },
            { key: "c", text: "Compre cripto e esqueça o resto" },
            { key: "d", text: "Todo investimento gera lucro" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "finalizacion",
      navLabel: "Parabéns por chegar até aqui!",
      title: "🎖️ Parabéns por chegar até aqui!",
      content: [
        "“Investir em sua educação financeira e digital é uma das melhores decisões que você pode tomar.”",
      ],
    },
    {
      id: "reflexion-final",
      navLabel: "Reflexão final",
      title: "💭 Reflexão final (opcional, mas recomendada)",
      content: [
        {
          type: "paragraph",
          text: "Tema sugerido:",
        },
        {
          type: "paragraph",
          text: "“O que aprendi e como aplicarei?”",
        },
        {
          type: "paragraph",
          text: "Você pode escrever um texto breve (1 a 2 páginas) ou gravar um áudio/vídeo curto, compartilhando:",
        },
        {
          type: "list",
          items: [
            "Quais módulos mais te impactaram?",
            "Quais hábitos você mudou ou pretende mudar?",
            "O que aprendeu sobre si mesmo e sua relação com o dinheiro digital?",
            "Como usará esse conhecimento na sua vida pessoal ou profissional?",
          ],
        },
      ],
    },
  ],
};

export default modulo9_pt;
